import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AggiungiQuadro.css";

function AggiungiQuadro() {
    const [file, setFile] = useState(null);
    const [title, setTitle] = useState("");
    const [dimension, setDimension] = useState("");
    const [genre, setGenre] = useState("");
    const [quantity, setQuantity] = useState(1);
    const [percentage, setPercentage] = useState("");
    const [bn, setBn] = useState(false);
    const [sandy, setSandy] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false); // 🔹 stato per bottone verde
    const navigate = useNavigate();

    const handleFileChange = (e) => {
        if (e.target.files.length > 0) {
            setFile(e.target.files[0]);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        if (e.dataTransfer.files.length > 0) {
            setFile(e.dataTransfer.files[0]);
        }
    };

    const handleDragOver = (e) => e.preventDefault();

    const handleBnChange = (e) => {
        const checked = e.target.checked;
        if (checked && sandy) {
            setSandy(false);
        }
        setBn(checked);
    };

    const handleSandyChange = (e) => {
        const checked = e.target.checked;
        if (checked && bn) {
            setBn(false);
        }
        setSandy(checked);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess(false);

        if (!file) {
            setError("Carica un'immagine");
            return;
        }

        const formData = new FormData();
        formData.append("immagine", file);
        formData.append("title", title);
        formData.append("dimension", dimension);
        formData.append("genre", genre);
        formData.append("quantity", quantity);
        formData.append("percentage", percentage);
        formData.append("bn", bn);
        formData.append("sandy", sandy);

        try {
            const response = await fetch("/api/add-quadro", {
                method: "POST",
                body: formData,
            });

            const data = await response.json();
            if (data.success) {
                // 🔹 bottone verde per 1 secondo
                setSuccess(true);
                setTimeout(() => setSuccess(false), 1000);

                // reset campi
                setFile(null);
                setTitle("");
                setDimension("");
                setGenre("");
                setQuantity(1);
                setPercentage("");
                setBn(false);
                setSandy(false);
            } else {
                setError(data.message || "Errore nell'inserimento");
            }
        } catch {
            setError("Errore di connessione al server");
        }
    };

    const handleGoHome = () => {
        navigate("/home");
    };

    return (
        <div id="container">
            {/* Navbar */}
            <div id="nav_bar">
                <div id="logo_container">
                    <img
                        id="logo_title"
                        src={"logo-header.png"}
                        alt="Logo"
                    />
                </div>
                <div id="title">
                    <p>Aggiungi Quadro</p>
                </div>
                <div id="logout_button">
                    <button id="logout" onClick={handleGoHome}>Torna indietro</button>
                </div>
            </div>

            {/* Form */}
            <form id="form_container" onSubmit={handleSubmit}>
                <div className="form_item full">
                    <label>Immagine</label>
                    <div
                        className={`dropzone ${file ? "disabled" : ""}`}
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                    >
                        {!file ? (
                            <>
                                <p className="file-text">Trascina qui o seleziona un file</p>
                                <label className="custom-file-upload">
                                    <input
                                        type="file"
                                        name="immagine"
                                        accept="image/*"
                                        onChange={handleFileChange}
                                    />



                                    📂 Scegli immagine
                                </label>
                            </>
                        ) : (
                            <div className="file_preview">
                                <p>{file.name}</p>
                                <button
                                    type="button"
                                    className="btn-remove"
                                    onClick={() => setFile(null)}
                                >
                                    Rimuovi
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                <div className="form_item">
                    <label>Titolo</label>
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        required
                    />
                </div>

                <div className="form_item">
                    <label>Dimensione</label>
                    <select
                        value={dimension}
                        onChange={(e) => setDimension(e.target.value)}
                        required
                    >
                        <option value="">Seleziona</option>
                        <option>15X20</option>
                        <option>16X16</option>
                        <option>10X45</option>
                        <option>25X25</option>
                        <option>25X35</option>
                        <option>20X50</option>
                        <option>20X60</option>
                        <option>20X80</option>
                        <option>20X110</option>
                        <option>30X60</option>
                        <option>36X60</option>
                        <option>60X80</option>
                        <option>40X120</option>
                    </select>
                </div>

                <div className="form_item">
                    <label>Genere</label>
                    <select
                        value={genre}
                        onChange={(e) => setGenre(e.target.value)}
                        required
                    >
                        <option value="">Seleziona</option>
                        <option>Horror</option>
                        <option>Anime</option>
                        <option>Cinema</option>
                        <option>Videogiochi</option>
                        <option>Musica</option>
                        <option>Pop Art</option>
                        <option>Sport</option>
                        <option>Japan</option>
                        <option>Classic Art</option>
                    </select>
                </div>

                <div className="form_item">
                    <label>Quantità</label>
                    <input
                        type="number"
                        min="1"
                        value={quantity}
                        onChange={(e) => setQuantity(e.target.value)}
                        required
                    />
                </div>

                <div className="form_item">
                    <label>Percentuale (%)</label>
                    <input
                        type="number"
                        min="0"
                        max="100"
                        value={percentage}
                        onChange={(e) => {
                            let val = parseInt(e.target.value, 10);
                            if (isNaN(val)) {
                                setPercentage("");
                            } else {
                                if (val > 100) val = 100;
                                if (val < 0) val = 0;
                                setPercentage(val);
                            }
                        }}
                        required
                    />
                </div>

                {/* Checkboxes B/N e Sandy */}
                <div className="form_item full">
                    <label>Opzioni</label>
                    <div className="checkbox-group">
                        <label>
                            <input
                                type="checkbox"
                                checked={bn}
                                onChange={handleBnChange}
                            />
                            B/N
                        </label>
                        <label>
                            <input
                                type="checkbox"
                                checked={sandy}
                                onChange={handleSandyChange}
                            />
                            S
                        </label>
                    </div>
                </div>

                {error && <p id="errore_text">{error}</p>}

                <div className="form_item full buttons">
                    <button
                        type="submit"
                        className={`btn-visualizza ${success ? "btn-success" : ""}`}
                    >
                        Conferma
                    </button>
                </div>
            </form>
        </div>
    );
}

export default AggiungiQuadro;
